import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpProjects(type, page) {
    const url = (type === "my-projects" ? `${API_ECP_PROJECTS}?public=false` : type === "recycle-bin" ? `${API_ECP_PROJECTS}?deleted=true` : type === "shared-projects" ? `${API_ECP_PROJECTS}?public=true` : API_ECP_PROJECTS)
    + (page ? `&limit=8&offset=${page === 1 ? 0 : ((page - 1) * 8)}` : "")
    const {data, mutate, error} = useSWR(url, {refreshInterval: 10000})
    return {
        ecpProjects: data,
        mutateEcpProjects: mutate,
        isLoadingEcpProjects: !error && !data,
        isErrorEcpProjects: error
    }
}